import { useQuery } from "@tanstack/react-query";
import { getQararkStatus } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useQararkStatus({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.qararkStatus,
    queryFn: getQararkStatus,
    staleTime: staleTimes.qararkStatus,
    enabled,
  });
}
